import { useQuery } from "@tanstack/react-query";

import { listArticlesOptions } from "../generated/client/octalog-service/@tanstack/react-query.gen";

export function useGetArticles() {
  return useQuery(listArticlesOptions());
}
